import { useMemo } from 'react';

import { useTranslation } from 'react-i18next';

import { tocLobbyRiveUrl } from '../../../../services/ui';
import { useStores } from '../../../../stores/useStores';

import type { TocLobbyBannerValues } from './tocLobbyBanner';
import { buildTocLobbyBannerValues } from './tocLobbyBanner';

/**
 * The current coin's ToC lobby file and values from its page's `toc`, else `riveUrl: null` and the admin banner
 * shows; call from an observer. It comes with the banners response: no wait, no swap on a ToC fetch.
 */
export const useTocLobbyBanner = (
  isMobile: boolean,
): { riveUrl: string | null; values: TocLobbyBannerValues | null } => {
  const { uiStore, coinTypeStore, tournamentStore } = useStores();
  const { t, i18n } = useTranslation();
  const { lobby_cc, lobby_sc } = uiStore.bannerByPage;
  const toc = (coinTypeStore.coinType === 'GC' ? lobby_cc : lobby_sc)?.toc ?? null;

  const isOn = uiStore.bannerAnimationFlag && tournamentStore.tournamentsFlag;
  const fileUrl = isOn && toc ? tocLobbyRiveUrl(toc, isMobile) : null;
  const riveUrl = fileUrl && !uiStore.failedTocLobbyRiveUrls.has(fileUrl) ? fileUrl : null;

  const values = useMemo(
    () => (riveUrl && toc ? buildTocLobbyBannerValues(toc, t, i18n.language) : null),
    [riveUrl, toc, t, i18n.language],
  );

  return { riveUrl, values };
};
